import React, { useMemo } from 'react';
import { Button } from 'antd';
import PersonRow from './PersonRow';
import type { TSubmitProvider } from '../types';
import s from '../s.module.less';

type Props = {
    people: TSubmitProvider[];
    selected: Record<number, boolean>;
    inviting: boolean;
    onBack: () => void;
    onToggle: (providerId: number, checked: boolean) => void;
    onSelectAll: (checked: boolean) => void;
    onInvite: () => void;
    onTrack: () => void;
};

// group only：挑出要发 marketplace 邀请的 provider。邀请当场发出，发完停在本页，
// 行变成 Invited（服务端 portalStatus），owner 能接着邀请剩下的人。
export default function ChooseProvidersScreen({
    people,
    selected,
    inviting,
    onBack,
    onToggle,
    onSelectAll,
    onInvite,
    onTrack,
}: Props) {
    const inviteable = useMemo(() => people.filter((p) => !p.invited), [people]);
    const selectedCount = inviteable.filter((p) => selected[p.providerId]).length;
    const allDone = people.length > 0 && inviteable.length === 0;
    const allSelected = inviteable.length > 0 && selectedCount === inviteable.length;

    return (
        <>
            <div className={s.backRow}>
                <Button type="link" onClick={onBack}>
                    Back
                </Button>
            </div>
            <div className={s.eyebrow}>Klarity Marketplace</div>
            <h1 className={s.h1}>Who&apos;s ready for new patients?</h1>
            <p className={s.lead}>
                {allDone
                    ? 'Everyone here has an invite. Each provider sets up their own login, rates and availability.'
                    : 'Start with any providers who want cash-pay bookings. You can add others later.'}
            </p>
            {inviteable.length > 0 && (
                <div className={s.selectAllRow}>
                    <Button type="link" onClick={() => onSelectAll(!allSelected)}>
                        {allSelected ? 'Clear all' : 'Select all'}
                    </Button>
                </div>
            )}
            <div className={`${s.card} ${s.listCard}`}>
                {people.map((p, i) => (
                    <PersonRow
                        key={p.providerId}
                        person={p}
                        first={i === 0}
                        last={i === people.length - 1}
                        checked={!!selected[p.providerId]}
                        onToggle={(checked) => onToggle(p.providerId, checked)}
                    />
                ))}
            </div>
            <div className={s.actions}>
                {allDone ? (
                    <Button type="primary" onClick={onTrack}>
                        Back to credentialing
                    </Button>
                ) : (
                    <>
                        <Button
                            type="primary"
                           
                            disabled={selectedCount === 0}
                            loading={inviting}
                            onClick={onInvite}
                        >
                            Invite selected providers
                        </Button>
                        <Button type="link" onClick={onTrack}>
                            Back to credentialing
                        </Button>
                    </>
                )}
            </div>
        </>
    );
}
